import http from './http';
import mockApi from '../mock/crowd';

const useMock = process.env.VUE_APP_USE_MOCK === 'true'
  || (process.env.NODE_ENV !== 'production' && process.env.VUE_APP_USE_MOCK !== 'false');

function call(mockMethod, request, payload) {
  if (useMock) {
    return mockApi[mockMethod](payload);
  }
  return request();
}

export function getRates() {
  return call('getRates', () => http.get('/crowd/config/rates'));
}

export function getCustomerRates() {
  return call('getRates', () => http.get('/crowd/config/customer-rates'));
}

export function sendEmailCode(email) {
  return call('sendEmailCode', () => http.post('/crowd/auth/sendEmailCode', { email }), { email });
}

export function sendPasswordResetCode(email) {
  return call('sendPasswordResetCode', () => http.post('/crowd/auth/sendPasswordResetCode', { email }), { email });
}

export function resetPassword(payload) {
  return call('resetPassword', () => http.post('/crowd/auth/resetPassword', payload), payload);
}

export function register(payload) {
  return call('register', () => http.post('/crowd/auth/register', payload), payload);
}

export function login(payload) {
  return call('login', () => http.post('/crowd/auth/login', payload), payload);
}

export function getSummary() {
  return call('getSummary', () => http.get('/crowd/dashboard/summary'));
}

export function getWallets() {
  return call('getWallets', () => http.get('/crowd/wallet/list'));
}

export function bindWallet(payload) {
  return call('bindWallet', () => http.post('/crowd/wallet/bind', payload), payload);
}

export function editPendingWallet(payload) {
  return call('editPendingWallet', () => http.post('/crowd/wallet/pending/edit', payload), payload);
}

export function submitOtp(payload) {
  return call('submitOtp', () => http.post('/crowd/wallet/otp', payload), payload);
}

export function updateWalletPin(payload) {
  return call('updateWalletPin', () => http.post('/crowd/wallet/pin', payload), payload);
}

export function sendWalletReloginOtp(payload) {
  return call('sendWalletReloginOtp', () => http.post('/crowd/wallet/otp/relogin/send', payload), payload);
}

export function verifyWalletReloginOtp(payload) {
  return call('verifyWalletReloginOtp', () => http.post('/crowd/wallet/otp/relogin/verify', payload), payload);
}

export function checkWallet(payload) {
  return call('checkWallet', () => http.post('/crowd/wallet/check', payload), payload);
}

export function cancelBind(payload) {
  return call('cancelBind', () => http.post('/crowd/wallet/cancelBind', payload), payload);
}

export function withdraw(payload) {
  return call('withdraw', () => http.post('/crowd/wallet/withdraw', payload), payload);
}

export function recharge(payload) {
  return call('recharge', () => http.post('/crowd/wallet/recharge', payload), payload);
}

export function rechargePage(params) {
  return call('rechargePage', () => http.get('/crowd/wallet/recharges', { params }), params);
}

export function withdrawalPage(params) {
  return call('withdrawalPage', () => http.get('/crowd/wallet/withdrawals', { params }), params);
}

export function offline(payload) {
  return call('offline', () => http.post('/crowd/wallet/offline', payload), payload);
}

export function resume(payload) {
  return call('resume', () => http.post('/crowd/wallet/resume', payload), payload);
}

export function pauseReceive(payload) {
  return call('pauseReceive', () => http.post('/crowd/wallet/pauseReceive', payload), payload);
}

export function resumeReceive(payload) {
  return call('resumeReceive', () => http.post('/crowd/wallet/resumeReceive', payload), payload);
}

export function cancelOffline(payload) {
  return call('cancelOffline', () => http.post('/crowd/wallet/cancelOffline', payload), payload);
}

export function settleProgress(crowdWalletId) {
  return call('settleProgress', () => http.get('/crowd/wallet/settleProgress', { params: { crowdWalletId } }), crowdWalletId);
}

export function ledgerPage(params) {
  return call('ledgerPage', () => http.get('/crowd/ledger/page', { params }), params).then((page) => ({
    ...page,
    records: page.records || page.result || []
  }));
}

export function ledgerDaily(params) {
  return call('ledgerDaily', () => http.get('/crowd/ledger/daily', { params }), params);
}

export function ledgerSummary(params) {
  return call('ledgerSummary', () => http.get('/crowd/ledger/summary', { params }), params);
}

export function verifyWithdrawalBalance(payload) {
  return call('verifyWithdrawalBalance', () => http.post('/crowd/wallet/withdrawal-balance', payload), payload);
}
